import { Container, Typography } from '@/src/ct-design/lib'
import React from 'react'

interface RetrieveApplicationCalloutProps {
    /**
     * Handler for retrieving application click
     */
    onRetrieveClick?: () => void
    /**
     * Handler for login click
     */
    onLoginClick?: () => void
    /**
     * Optional className
     */
    className?: string
}

/**
 * Footer component for retrieving application or logging in
 * Each word is in a separate Typography component to allow word-by-word wrapping
 */
const RetrieveApplicationCallout: React.FC<RetrieveApplicationCalloutProps> = ({
    onRetrieveClick,
    onLoginClick,
    className = ''
}) => {
    return (
        <Container className={`pt-6 ${className}`}>
            <Container className='flex flex-wrap flex-center'>
                <Typography variant='B2' color='placeholder'>
                    Already
                </Typography>
                <Typography variant='B2' color='placeholder' className='ml-1'>
                    Applied?
                </Typography>

                {/* Log In - clickable */}
                <span
                    onClick={onLoginClick}
                    role={onLoginClick ? 'button' : undefined}
                    tabIndex={onLoginClick ? 0 : undefined}
                    style={{ display: 'contents' }}
                    aria-label='Log In'
                    className='c-pointer'
                >
                    <Typography
                        variant='B2'
                        color='link'
                        className='ml-1 c-pointer'
                    >
                        Log In
                    </Typography>
                </span>

                <Typography variant='B2' className='ml-1'>
                    to
                </Typography>
                <Typography variant='B2' className='ml-1'>
                    upload
                </Typography>
                <Typography variant='B2' className='ml-1'>
                    documents
                </Typography>
                <Typography variant='B2' className='ml-1'>
                    and
                </Typography>
                <Typography variant='B2' className='ml-1'>
                    track
                </Typography>
                <Typography variant='B2' className='ml-1'>
                    status.
                </Typography>
            </Container>
        </Container>
    )
}

export default RetrieveApplicationCallout
